<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 82 100">
    <g :fill="iconColor" fill-rule="evenodd">
      <path
        d="M36.25 65.09c.343-.269.515-.643.515-1.122 0-.48-.168-.85-.504-1.112-.337-.262-.797-.392-1.382-.392h-2.61v3.029h2.61c.57 0 1.027-.134 1.37-.403"
      />
      <path
        d="M47.553 70.048c.833.784 1.85 1.177 3.048 1.177 1.023 0 1.834-.24 2.434-.72v-4.99h3.969v6.778c-.614.668-1.499 1.242-2.654 1.721a10.167 10.167 0 0 1-3.749.698c-2.368 0-4.356-.741-5.964-2.223-1.594-1.496-2.39-3.4-2.39-5.71 0-2.325.803-4.228 2.412-5.71 1.593-1.482 3.625-2.223 6.096-2.223 1.593 0 3.084.363 4.473 1.09v3.683c-1.418-.77-2.815-1.155-4.189-1.155-1.388 0-2.529.407-3.42 1.22-.877.814-1.316 1.867-1.316 3.16 0 1.351.417 2.42 1.25 3.204zm-19.23 4.359V59.15h6.841c1.725 0 3.084.443 4.079 1.33 1.008.886 1.513 2.034 1.513 3.443 0 1.41-.505 2.564-1.513 3.465-.995.886-2.354 1.33-4.079 1.33H32.27v5.688h-3.947zm42.884 19.075H16.07c-2.287 0-4.148-1.85-4.148-4.125v-4.77h51.4c2.384 0 4.316-1.918 4.316-4.288v-26.01c0-2.37-1.932-4.29-4.315-4.29H11.922V10.644c0-2.269 1.861-4.119 4.148-4.119l37.957-.04V20.43c0 4.073 3.325 7.38 7.426 7.38l13.744-.039.154 61.586c0 2.275-1.857 4.125-4.144 4.125zM9.772 59.15h3.925l3.882 5.863 3.903-5.863h3.903v15.256H21.46V65.1l-2.741 4.097h-2.171L13.719 65.1v9.306H9.772V59.15zM56.48 0H16.07C10.166 0 5.36 4.779 5.36 10.643V50H4.316C1.932 50 0 51.92 0 54.289v26.01c0 2.37 1.932 4.288 4.315 4.288h1.046v4.77C5.36 95.227 10.166 100 16.07 100h55.137c5.901 0 10.707-4.773 10.707-10.643V25.19L56.48 0z"
      />
      <path
        d="M42.092 25.235l-12.517-8.517c-.578-.393-1.16-.602-1.644-.602-.936 0-1.515.747-1.515 1.997V36.52c0 1.248.578 1.993 1.511 1.993.485 0 1.059-.208 1.638-.603l12.523-8.517c.805-.548 1.251-1.286 1.251-2.08 0-.791-.44-1.53-1.247-2.078"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-mpg',
    props: {
      width: {
        type: [Number, String],
        default: 82
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
